import styled from '@emotion/styled';
import { spacing } from '#themes/stena-recycling';

export const LoadMoreWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: ${spacing.small};
  width: 100%;
`;
